<template>
  <k-page class="page-news-create">
    <the-news-create />
  </k-page>
</template>

<script>
/**
 * Component: page-news-create - Страница создания новости
*
* @version 1.0.0
*/


// Components
import TheNewsCreate from '@/components/TheNewsCreate.vue';
import KPage from '@/components/KPage.vue';


export default {
  name: 'page-news-create',

  components: {
    KPage,
    TheNewsCreate,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.page-news-create {
  $this: &;
}
</style>
